import Vue from "vue";
import { expertAPI } from "@/utils/apiUrls";
import sponsorship from "./sponsorship/index";

export default {
  namespaced: true,

  modules: {
    sponsorship,
  },

  state: {
    usercase: null,
    userflows: null,
    isUsercaseLoading: true,
  },

  getters: {},

  mutations: {
    updateUsercase(state, payload) {
      state.usercase = payload;
    },

    updateUserflows(state, payload) {
      state.userflows = payload;
    },

    setIsUsercaseLoading(state, payload) {
      state.isUsercaseLoading = payload;
    },
  },

  actions: {
    async takeCaseInReview({ dispatch }, payload) {
      await Vue.axios
        .get(expertAPI.usercase.sponsorship.review.ResumeCaseReviewURL(payload))
        .then(() => dispatch("expert/refreshData", null, { root: true }));
    },

    async refreshCaseUserflows({ commit, state }) {
      await Vue.axios
        .get(
          expertAPI.usercase.sponsorship.GetCaseUserflowsURL(state.usercase.ID)
        )
        .then((resp) => {
          commit("updateUserflows", resp.data);
        })
        .catch((err) => console.error(err));
    },

    async refreshUsercase({ commit, rootState }) {
      commit("setIsUsercaseLoading", true);
      await Vue.axios
        .get(expertAPI.usercase.GetCaseURL(rootState.route.params.case_id))
        .then((resp) => {
          commit("updateUsercase", resp.data);
          commit("setIsUsercaseLoading", false);
        })
        .catch((err) => console.error(err));
    },

    async refreshUsercaseByID({ commit, dispatch /*, rootState */ }, payload) {
      commit("setIsUsercaseLoading", true);
      // console.log(rootState.route);
      await Vue.axios
        .get(expertAPI.usercase.GetCaseURL(payload))
        .then((resp) => {
          commit("updateUsercase", resp.data);
          dispatch("refreshCaseUserflows");
          commit("setIsUsercaseLoading", false);
        })
        .catch((err) => console.error(err));
    },
  },
};
